import { useState } from 'react';
import Input from '../../../../Core/Fields/Floating/Input';
import SelectSearch from '../../../../Core/Fields/Floating/SelectSearch';
import Checkbox from '../../../../Core/Fields/Floating/Checkbox';
const Tab1 = ({ parentcompany, fullcompanylist, accounts, formData, onInputChange }) => {
    const accountOptions = [
        { name: 'Test Account 1' },
        { name: 'Test Account 2' },
        { name: 'Test Account 3' },
    ];

    return (
    <div>
            <div className="px-2 py-3" style={{ background: 'white' }}>
                <div style={{ display: 'flex' }} >
                    <div className="col-md-6 px-2">
                        <div className='' style={{ backgroundColor: '#EBE6FA', height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
                            <div style={{ display: 'flex', gap: '15px' }}>
                                <div style={{ flex: 1 }}>
                                    <p className='m-0' style={{ fontSize: '16px', fontWeight: '600' }}>Details</p>
                                </div>
                            </div>
                            <div style={{ display: 'flex', gap: '15px' }}>
                                <div style={{ flex: 1 }}>
                                    <Checkbox
                                        id="isRejectedWarehouse"
                                        label="is RejectedWarehouse"
                                        checked={true}
                                        value={formData?.isRejectedWarehouse || false}
                                        onChange={(checked) => onInputChange("isRejectedWarehouse", checked)}
                                    />
                                    <div style={{ fontSize: "9px", color: "#00000099", marginLeft: '23px' }}>
                                        If yes, then this warehouse will be used to store rejected materials
                                    </div>

                                </div>
                                <div style={{ flex: 1 }}>
                                    <Input
                                        id="Bin Name"
                                        label="Bin Name"
                                        style={{ height: "30px" }}
                                        value={formData?.warehouseName}
                                        onChange={(e) => onInputChange('warehouseName', e.target.value)}
                                        readOnly
                                    />
                                </div>
                                <div style={{ flex: 1 }}>
                                    <SelectSearch
                                        list={parentcompany || []}
                                        label="Parent Warehouse"
                                        getOptionLabel={(item) => item.name}
                                        getOptionValue={(item) => item.name}
                                        value={formData?.parentWarehouse}
                                        onChange={(value) => onInputChange('parentWarehouse', value)}
                                        placeholder=""
                                    />
                                </div>
                            </div>


                        </div>
                    </div>

                    <div className="col-md-6 px-2">
                        <div className='' style={{ backgroundColor: '#E3F5DF', height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
                            <div style={{ display: 'flex', gap: '15px' }}>
                                <div style={{ flex: 1, height:'24px' }}>
                                    <p className='m-0' style={{ fontSize: '16px', fontWeight: '600' }}></p>
                                </div>
                            </div>
                            <div style={{ display: 'flex', gap: '15px' }}>


                                <div style={{ flex: 1 }}>
                                    <SelectSearch
                                        list={fullcompanylist || []}
                                        label="Company"
                                        getOptionLabel={(item) => item.name}
                                        getOptionValue={(item) => item.name}
                                        value={formData?.company}
                                        onChange={(value) => onInputChange('company', value)}
                                        placeholder=""
                                    />
                                </div>

                                <div style={{ flex: 1 }}>
                                    <SelectSearch
                                        list={accounts || []}
                                        label="Account"
                                        getOptionLabel={(item) => item.name}
                                        getOptionValue={(item) => item.name}
                                        value={formData?.account}
                                        onChange={(value) => onInputChange('account', value)}
                                        placeholder=""
                                    />

                                </div>
                                <div style={{ flex: 1 }}>
                                    <Input
                                        id="Abbr"
                                        label="Abbr"
                                        style={{ height: "30px" }}
                                        value={formData?.abbr}
                                        onChange={(e) => onInputChange('abbr', e.target.value)}
                                    />
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
};

export default Tab1;